import {useTheme} from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Paper} from "@mui/material";
import React from "react";
import {
    alphaNumericValidator,
    emailValidator,
    phoneNumberValidator
} from "../../Helpers/ValidationHelpers";
import ValidatedTextField from "../Inputs/ValidatedTextField";

const ClientContactView = ({
                               client,
                               edit,
                               setActiveForm,
                               isSubmitting,
                               formValid
                           }) => {
    const theme = useTheme();

    const fields = [
        {
            id: "contact1Name",
            label: "Name",
            value: client.contact1Name,
            validator: alphaNumericValidator,
            onChange: isValid => (formValid.current.contact1Name = isValid),
            initialValue: client.contact1Name,
            fieldPath: ['contact1Name'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        },
        {
            id: "contact1Email",
            label: "Email",
            value: client.contact1Email,
            validator: emailValidator,
            onChange: isValid => (formValid.current.contact1Email = isValid),
            initialValue: client.contact1Email,
            fieldPath: ['contact1Email'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        },
        {
            id: "contact1Phone",
            label: "Phone",
            value: client.contact1Phone,
            validator: phoneNumberValidator,
            onChange: isValid => (formValid.current.contact1Phone = isValid),
            initialValue: client.contact1Phone,
            fieldPath: ['contact1Phone'],
            infoAdornment: null,
            size: "small",
            removeHelperTextPadding: true
        }
    ]
    return (
        <Paper className="paper-rounded-edges">
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" className="detail-header-banner">Primary Contact</Typography>
                </Grid>
                {fields.map((field, index) => (
                    <Grid size={{ xs: 12}} key={index}>
                        <Box
                            sx={{
                                display:'flex',
                                justifyContent: 'space-between',
                                padding: '10px',
                                alignItems: 'center',
                                borderBottom: `1px solid ${theme.palette.divider}`
                            }}
                        >
                            <Typography sx={{ fontWeight: 'bold'}}>{field.label}</Typography>
                            {!edit &&
                                <Typography>{field.value}</Typography>
                            }
                            {edit &&
                                <ValidatedTextField
                                    id={field.id}
                                    label={null}
                                    validator={field.validator}
                                    onChange={field.onChange}
                                    setActiveForm={setActiveForm}
                                    isSubmitting={isSubmitting}
                                    initialValue={field.initialValue}
                                    fieldPath={field.fieldPath}
                                    infoAdornment={field.infoAdornment}
                                    size={field.size}
                                    removeHelperTextPadding={field.removeHelperTextPadding}
                                    width={{xs: 200, md: 250}}
                                />
                            }
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    )
}

export default ClientContactView;